window.productSlider = null;
let productSwiper;
let productSecondarySwiper;
let pdpSwiperInitialized = false;

// function filterSlidesByColorTitle(colorTitle) {
//   const mainSlides = document.querySelectorAll('.swiper.product-main-swiper .c-swiper-slide');
//   const secondarySlides = document.querySelectorAll('.swiper.product-secondary-swiper .c-swiper-slide');

//   if (!colorTitle) return;

//   const shouldAlwaysShow = (slide) => {
//     return (
//       slide.classList.contains('is-settings-video') ||
//       slide.classList.contains('is-settings-video-thumb')
//     );
//   };

//   mainSlides.forEach((slide) => {
//     if (shouldAlwaysShow(slide)) {
//       slide.classList.remove('is--hide');
//       slide.classList.add('swiper-slide');
//       return;
//     }

//     const alt = slide.dataset.alt;
//     if (alt && alt === colorTitle) {
//       slide.classList.remove('is--hide');
//       slide.classList.add('swiper-slide');
//     } else {
//       slide.classList.add('is--hide');
//       slide.classList.remove('swiper-slide');
//     }
//   });

//   secondarySlides.forEach((slide) => {
//     if (shouldAlwaysShow(slide)) {
//       slide.classList.remove('is--hide');
//       slide.classList.add('swiper-slide');
//       return;
//     }

//     const alt = slide.dataset.alt;
//     if (alt && alt === colorTitle) {
//       slide.classList.remove('is--hide');
//       slide.classList.add('swiper-slide');
//     } else {
//       slide.classList.add('is--hide');
//       slide.classList.remove('swiper-slide');
//     }
//   });
// }

function filterSlidesByColorTitle(colorTitle) {
  const mainRoot = document.querySelector('.swiper.product-main-swiper');
  const thumbRoot = document.querySelector('.swiper.product-secondary-swiper');
  if (!mainRoot || !thumbRoot) return;

  const mainSlides = mainRoot.querySelectorAll('.swiper-wrapper > .c-swiper-slide');
  const thumbSlides = thumbRoot.querySelectorAll('.swiper-wrapper > .c-swiper-slide');

  const apply = (slide) => {
    const alt = (slide.dataset.alt || '').trim();

    // показываем только те, у кого alt === colorTitle
    const shouldShow = alt === colorTitle;

    slide.classList.toggle('is--hide', !shouldShow);

    // ВАЖНО: именно это решает “невидимый, но считается”
    if (shouldShow) {
      slide.classList.add('swiper-slide');
      slide.style.removeProperty('display');
      slide.style.removeProperty('visibility');
      slide.style.removeProperty('opacity');
    } else {
      slide.classList.remove('swiper-slide');

      // чтобы Swiper/тема не держали место
      slide.style.display = 'none';
    }
  };

  mainSlides.forEach(apply);
  thumbSlides.forEach(apply);

  // если Swiper уже есть — пересчитываем и НЕ даём уйти в пустоту
  const mainSwiper = mainRoot.swiper;
  const thumbSwiper = thumbRoot.swiper;

  if (mainSwiper && thumbSwiper) {
    mainSwiper.updateSlides();
    mainSwiper.update();
    thumbSwiper.updateSlides();
    thumbSwiper.update();

    // жёстко возвращаем на 0, потому что активный индекс мог стать “пустым”
    mainSwiper.slideTo(0, 0, false);
    thumbSwiper.slideTo(0, 0, false);
  }
}


function destroyPDPSwipers() {
  if (productSwiper) {
    productSwiper.destroy(true, false);
    productSwiper = null;
  }

  if (productSecondarySwiper) {
    productSecondarySwiper.destroy(true, false);
    productSecondarySwiper = null;
  }
}

function initPDPSwipers() {
  const mainPDPSwiper = document.querySelector('.swiper.product-main-swiper');
  const secondarySwiper = document.querySelector('.swiper.product-secondary-swiper');

  if (!mainPDPSwiper || !secondarySwiper) return;

  productSwiper = new Swiper(mainPDPSwiper, {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 600,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    }
  });

  window.productSlider = productSwiper;

  productSecondarySwiper = new Swiper(secondarySwiper, {
    slidesPerView: 8.6,
    spaceBetween: 8,
    speed: 400,
    watchSlidesProgress: true,
  });

  productSecondarySwiper.on('click', function (swiper) {
    setTimeout(() => {
      const clickedIndex = swiper.clickedIndex;

      if (clickedIndex !== undefined) {
        productSwiper.slideTo(clickedIndex);

        swiper.slides.forEach(slide => slide.classList.remove('swiper-slide-active'));

        if (swiper.slides[clickedIndex]) {
          swiper.slides[clickedIndex].classList.add('swiper-slide-active');
        }

        productSecondarySwiper.slideTo(clickedIndex);
      }
    }, 0);
  });

  productSwiper.on('slideChange', function () {
    setTimeout(() => {
      const activeIndex = productSwiper.realIndex;

      const oldActive = secondarySwiper.querySelectorAll('.swiper-slide-active');
      oldActive.forEach(slide => slide.classList.remove('swiper-slide-active'))

      const activeSlide = productSecondarySwiper.slides[activeIndex];
      if (activeSlide) {
        activeSlide.classList.add('swiper-slide-active');
      }
    }, 0);
  });

  productSecondarySwiper.on('slideChange', function () {
    setTimeout(() => {
      const activeIndex = productSecondarySwiper.realIndex;
      productSwiper.slideTo(activeIndex);
    }, 0);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const colorItems = document.querySelectorAll('.c-color-item');
  const addToCartBtn = document.querySelector('.product-form__buttons button.button-component');
  const variantIdInput = document.querySelector('.product-form form .product-variant-id');
  const isProductTemplate = document.body.classList.contains('template-product');

  if (!addToCartBtn || !variantIdInput || !colorItems.length) {
    initPDPSwipers();
    pdpSwiperInitialized = true;
    return;
  }

  const addToCartText = addToCartBtn.querySelector('.button-component__text');

  function updatePriceHandler(item) {
    const comparePriceElement = document.querySelector('.featured-product__price-compare');
    const priceElement = document.querySelector('.featured-product__price-current');

    const price = item.getAttribute('data-price');
    const comparePrice = item.getAttribute('data-compare-price');

    if (comparePrice > price) {
      comparePriceElement.innerText = item.getAttribute('data-compare-price-formatted');
    } else {
      comparePriceElement.innerText = '';
    }

    priceElement.innerText = item.getAttribute('data-price-formatted');
  }

  function updateButtonStateByAvailability(isAvailable) {
    if (!addToCartText) return;

    if (isAvailable === 'false') {
      addToCartBtn.setAttribute('disabled', 'disabled');
      addToCartText.innerText = addToCartText.dataset.soldOutText;
    } else {
      addToCartBtn.removeAttribute('disabled');
      addToCartText.innerText = addToCartText.dataset.text;
    }
  }

  function updateVariantId(id) {
    if (id) {
      variantIdInput.value = id;
    }
  }

  function updateUrlVariant(id) {
    if (!id || !isProductTemplate) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', id);
    window.history.replaceState({}, '', url.toString());
  }

  function selectColorItem(item, updateUrl = true) {
    if (!item) return;

    if(window.productSlider) {
      window.productSlider.slideTo(0);
    }

    const oldSelected = document.querySelector('.c-color-item.is--selected');
    if (oldSelected && oldSelected !== item) {
      oldSelected.classList.remove('is--selected');
    }

    item.classList.add('is--selected');

    const availability = item.dataset.available;
    const variantId = item.dataset.id;
    const colorTitle = item.dataset.title;

    const trigger = document.querySelector('.product-main-swiper__video');
    if (trigger) {
      const isSecond = (colorTitle === 'Black'); // <-- поменяй под своё название второго варианта

      const url1 = (trigger.dataset.videoUrlDefault || trigger.dataset.videoUrl || '').trim();
      const file1 = (trigger.dataset.videoFileDefault || trigger.dataset.videoFile || '').trim();

      const url2 = (trigger.dataset.videoUrlSecond || '').trim();
      const file2 = (trigger.dataset.videoFileSecond || '').trim();

      // если ещё не сохранили "дефолт" — сохраним
      if (!trigger.dataset.videoUrlDefault) trigger.dataset.videoUrlDefault = url1;
      if (!trigger.dataset.videoFileDefault) trigger.dataset.videoFileDefault = file1;

      if (isSecond) {
        trigger.dataset.videoUrl = url2;
        trigger.dataset.videoFile = file2;
      } else {
        trigger.dataset.videoUrl = trigger.dataset.videoUrlDefault || '';
        trigger.dataset.videoFile = trigger.dataset.videoFileDefault || '';
      }
    }

    const customTitle = item.dataset.titleCustom;

    const productTitleElement = document.querySelector('.featured-product__product-title');
    if(productTitleElement && customTitle) {
      productTitleElement.innerText = customTitle;
    }

    const featuredItems = document.querySelectorAll('.featured-product__features .featured-product__feature');
    featuredItems.forEach(item => {
      const colors = item.dataset.variant.trim().split(',');
      let showItem = false;

      colors.forEach(color_item => {
        if (color_item == colorTitle) {
          showItem = true;
        }
      });

      if (showItem == true) {
        item.style.display = 'flex';
      } else {
        item.style.display = 'none';
      }
    });

    updateButtonStateByAvailability(availability);
    updateVariantId(variantId);
    updatePriceHandler(item);

    if (updateUrl) {
      updateUrlVariant(variantId);
    }

    if (!colorTitle) return;

    if (pdpSwiperInitialized) {
      destroyPDPSwipers();
    }

    filterSlidesByColorTitle(colorTitle);

    initPDPSwipers();
    pdpSwiperInitialized = true;

    setTimeout(() => {
      if (productSwiper) {
        productSwiper.updateSlides();
        productSwiper.update();
        productSwiper.slideTo(0, 0, false);
      }
      if (productSecondarySwiper) {
        productSecondarySwiper.updateSlides();
        productSecondarySwiper.update();
        productSecondarySwiper.slideTo(0, 0, false);
      }
    }, 0);
  }

  if (isProductTemplate) {
    const urlParams = new URLSearchParams(window.location.search);
    const urlVariantId = urlParams.get('variant');

    if (urlVariantId) {
      const itemFromUrl = Array.from(colorItems).find(
        (item) => item.dataset.id === urlVariantId
      );

      if (itemFromUrl) {
        selectColorItem(itemFromUrl, false);
      } else {
        const defaultSelected = document.querySelector('.c-color-item.is--selected') || colorItems[0];
        if (defaultSelected) selectColorItem(defaultSelected, true);
      }
    } else {
      const defaultSelected = document.querySelector('.c-color-item.is--selected') || colorItems[0];
      if (defaultSelected) selectColorItem(defaultSelected, true);
    }
  } else {
    const defaultSelected = document.querySelector('.c-color-item.is--selected') || colorItems[0];
    if (defaultSelected) selectColorItem(defaultSelected, false);
  }

  colorItems.forEach(item => {
    item.addEventListener('click', () => {
      selectColorItem(item, true);
    });
  });
});
